import styles from "./Contacts.module.scss";
import Heading from "../Typography/Heading/Heading";
import Text from "../Typography/Text/Text";
import YandexMap from "../YandexMap/YandexMap";
import { useState } from "react";
import marker from "../../static/images/marker_info.svg";

export default function Contacts() {
  const [clickedAddress, setClickedAddress] = useState({ addressIdx: null });
  const [mobileActiveTab, setMobileActiveTab] = useState("Список");

  function addressClickHandler(idx) {
    setClickedAddress((prev) => ({ ...prev, addressIdx: idx }));
    document
      .getElementById("mobileMap")
      .scrollIntoView({ block: "center", behavior: "smooth" });
  }

  function clickMobileTab(tabName) {
    setMobileActiveTab(tabName);
  }

  const addresses = [
    {
      address:
        "428015, Чувашская Республика, г. Чебоксары, пр. Московский, д. 33а",
      coordinates: [56.142276, 47.206564],
      title: "Электрозаправочный комплекс",
    },
    {
      address:
        "428003, Чувашская Республика, г. Чебоксары, Президентский бульвар, д. 4",
      coordinates: [56.142891, 47.245464],
      title: "Электрозаправочный комплекс",
    },
    {
      address: "428031, Чувашская Республика, г. Чебоксары, б-р Эгерский, д. 36",
      coordinates: [56.097559, 47.286725],
      title: "Электрозаправочный комплекс",
    },
    {
      address:
        "429555, Чувашская Республика, Моргаушский район, д. Тереси, ул.Новая, д. 71",
      coordinates: [56.040244, 46.810595],
      title: "Электрозаправочный комплекс",
    },
    {
      address:
        "429900, Чувашская Республика, Цивильский район, г. Цивильск, ул. Терешковой, д. 1",
      coordinates: [55.863258, 47.461979],
      title: "Электрозаправочный комплекс",
    },
    {
      address:
        "429060, Чувашская Республика - Чувашия, г. Ядрин, ул. Герцена, д. 9в",
      coordinates: [55.93478, 46.208125],
      title: "Электрозаправочная станция",
    },
    {
      address:
        "429350, Чувашская Республика - Чувашия, Батыревский район, с. Батырево, пр. Ленина, д. 22а",
      coordinates: [55.067375, 47.59675],
      title: "Электрозаправочная станция",
    },
    {
      address:
        "429955, Чувашская Республика - Чувашия, г. Новочебоксарск, ул. Винокурова, д. 21а",
      coordinates: [56.115143, 47.491432],
      title: "Электрозаправочная станция",
    },
    {
      address:
        "429120, Чувашская Республика - Чувашия, г. Шумерля, ул. Ленина, д. 34а",
      coordinates: [55.503701, 46.396871],
      title: "Электрозаправочная станция",
    },
  ];

  return (
    <div id="Contacts" className={styles.wrapper}>
      <div className="container">
        <div className={styles.title}>
          <Heading level="h3" fw={600}>
            Контакты
          </Heading>
        </div>
        <div className={styles.content}>
          <div className={styles.contacts}>
            <div
              className={
                mobileActiveTab === "Карта"
                  ? `${styles.map} ${styles.visibleForMobile}`
                  : `${styles.map}`
              }
            >
              <YandexMap
                clickedAddress={clickedAddress}
                addresses={addresses}
              />
            </div>
            <div className={styles.info}>
              <div className={styles.item}>
                <div className={styles.header}>
                  <Text size="large" fw={500}>
                    <a href="tel:+78002503181">8–800–250–31–81</a>
                  </Text>
                </div>
                <div className={styles.description}>
                  <Text size="small">
                    Техподдержка производителя станции E-PROM
                  </Text>
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.header}>
                  <Text size="large" fw={500}>
                    <a href="tel:+78005008056">8-800–500–80–56</a>
                  </Text>
                </div>
                <div className={styles.description}>
                  <Text size="small">
                    Техподдержка оператора ЭЗС Electrifly
                  </Text>
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.header}>
                  <Text size="large" fw={500}>
                    <a href="https://t.me/electrifly_bot" target="blank">
                      @electrifly_bot
                    </a>
                  </Text>
                </div>
                <div className={styles.description}>
                  <Text size="small">
                    Техподдержка производителя станции E-PROM
                  </Text>
                </div>
              </div>
            </div>
            <div className={styles.mobileTabs}>
              <div
                className={
                  mobileActiveTab === "Список"
                    ? `${styles.tab} ${styles.active}`
                    : `${styles.tab}`
                }
                onClick={() => clickMobileTab("Список")}
              >
                <Text size="small">Список</Text>
              </div>
              <div className={styles.divider} />
              <div
                className={
                  mobileActiveTab === "Карта"
                    ? `${styles.tab} ${styles.active}`
                    : `${styles.tab}`
                }
                onClick={() => clickMobileTab("Карта")}
              >
                <Text size="small">Карта</Text>
              </div>
            </div>
          </div>
          <div className={styles.wrap}>
            <div
              className={
                mobileActiveTab === "Список"
                  ? `${styles.addresses} ${styles.visibleForMobile}`
                  : `${styles.addresses}`
              }
            >
              {addresses.map((address, idx) => (
                <div
                  className={styles.address}
                  key={idx}
                  onClick={() => addressClickHandler(idx)}
                >
                  <div className={styles.header}>
                    <Text size="small_s">{address.title}</Text>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.marker}>
                      <img src={marker} alt="" />
                    </div>
                    <div className={styles.text}>
                      <Text size="base">{address.address}</Text>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.mobileMap} id="mobileMap">
              <YandexMap
                clickedAddress={clickedAddress}
                addresses={addresses}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
